import moment from 'moment';


// A helper function to extract database data into tables
// input: data:             database data, should be a json format
//        header:           the header of table
//        dataBaseHeader:   corresponding database header
// return: data for display tables
var extractData = function(data, header, dataBaseHeader) {
    let returndata = []

    if (header.length != dataBaseHeader.length) {
        // if length does not march, this function will have problem, thus, log a debug info
        console.log('header length does not match with database header length!!' + header.length + " : " +dataBaseHeader.legnth)
    } else {
        // length matches, safe to extract
        let length = header.length

        // iterate all data in the data array
        for (var itemindex in data) {
            // construct one data sample from data array element
            let tempdata= {}
            let item = data[itemindex]
            for (var i=0; i<length; i++ ) {
                // special case goes here
                if (header[i] == 'Category') {
                    if (item.strategic=='✔') {
                        tempdata[header[i]] = 'Strategic'
                    }
                    if (item.operational=='✔') {
                        tempdata[header[i]] = 'Operational'
                    }
                    if (item.compliance=='✔') {
                        tempdata[header[i]] = 'Compliance'
                    }
                    if (item.financial=='✔') {
                        tempdata[header[i]] = 'Financial'
                    }
                    if (item.technology=='✔') {
                        tempdata[header[i]] = 'Technology'
                    }
                } else if (header[i] == 'No') {
                    // extract the risk reference number only
                    tempdata[header[i]] = item[dataBaseHeader[i]].split(' ')[0]
                } else if (header[i] == 'Risk') {
                    // extract the risk name only
                    tempdata[header[i]] = item[dataBaseHeader[i]].split(' ').slice(1).join(' ')
                } else if (header[i] == 'Lead Risk Owners') {
                    // extract the lead owner only
                    tempdata[header[i]] = item[dataBaseHeader[i]].map((owner) =>{
                        if (owner.risk_lead == 'Yes') {
                            return (owner.risk_owners + ', ' + owner.ref_short_designation+ '. ')
                        }
                    })
                    
                } else if (header[i].includes('Date')) {
                    // extract the risk name only
                    tempdata[header[i]] = moment(item[dataBaseHeader[i]]).format("DD-MM-YYYY")
                } else {
                    tempdata[header[i]] = item[dataBaseHeader[i]]
                }

            }
            returndata.push(tempdata)
        }
    }
    return returndata
}

export { extractData }





// WEBPACK FOOTER //
// ./src/util/TableUtil.js